import { api } from "./api";

const KEY = "exhale_user_id";

export function getStoredUserId() {
  return localStorage.getItem(KEY);
}

export function setStoredUserId(id) {
  localStorage.setItem(KEY, id);
}

export async function ensureUser() {
  let id = getStoredUserId();
  if (id) {
    try {
      const { data } = await api.get(`/users/${id}`);
      return data;
    } catch (e) {
      // fall through to create
    }
  }
  const { data } = await api.post(`/users/init`, {});
  setStoredUserId(data.id);
  return data;
}

export async function regenerateHandle(userId) {
  const { data } = await api.post(`/users/${userId}/regenerate`, {});
  return data;
}
